import type { Maybe } from '@amazon/vinyl-util'

/** Whether the server offers this viewer only a 30s preview clip, never on-demand or shuffle. */
export function isPreviewOnlySelections(selections: Maybe<readonly Maybe<string>[]>): boolean {
    return selections?.length === 1 && selections[0] === 'PREVIEW'
}
